import { render, staticRenderFns } from "./AppPlans.vue?vue&type=template&id=4ec0e94c&scoped=true&"
import script from "./AppPlans.vue?vue&type=script&lang=js&"
export * from "./AppPlans.vue?vue&type=script&lang=js&"
import style0 from "./AppPlans.vue?vue&type=style&index=0&id=4ec0e94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0e94c",
  null
  
)

export default component.exports